<template>
  <!-- 검색어 입력창 -->
  <div class="wrap_inp">
    <input
      id="mmpSearchInp"
      ref="mmpSearchInp"
      v-model="searchQuery"
      placeholder="원하는 강의를 검색하세요."
      maxlength="120"
      type="text"
      autocomplete="off"
      @keyup.enter="onEnter"
      @keyup.exact="onKeyup"
      @focus.stop="activeSearchUiMobile"
      @click="onFocus"
    >
    <button
      v-show="searchQuery"
      class="btn_clear_inp_keyword"
      @click.stop="onClear"
    >검색어 삭제</button>

    <!-- 검색 레이어 닫기(MO) -->
    <button
      v-if="isMobile"
      class="btn_close_search_ui"
      @click.stop="closeSearchUi"
    >검색 레이어 닫기</button>
    <!-- // 검색 레이어 닫기(MO) -->
  </div>
  <!-- // 검색어 입력창 -->
</template>

<script>
import moment from 'moment'

export default {
  name: 'TotalSearchInput',
  metaInfo () {
    return {
      title: '멀티캠퍼스 :: 통합검색'
    }
  },
  props: {
    searchTxt: {
      type: String,
      default: ''
    },
    searchType: {
      type: String,
      default: 'TOTAL'
    },
    prePageSearchKeyword: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      searchQuery: '',
      isFocus: false,
      verticalPosition: -1,
      items: [],
      isDesktop: true, // 현재 디바이스 viewport width 가 데스크탑 사이즈인 경우 true
      isPopupVisible: false // 알림 팝업이 열려있는지 체크
    }
  },
  computed: {
    getSearchKeyword () {
      return this.$parent.searchKeyword
    },
    getSearchInput () {
      return this.$route.query.keyword
    },
    isMobile () {
      return !window.vue.getStore('homeInfo').state.isDeskTopMode
    }
  },
  watch: {
    searchQuery (val) {
      this.autoCorsSearch(val)
    }
  },
  mounted () {
    this.onFocus()
    this.setInitSearchKeyword()
  },
  beforeDestroy () {
    this.onClear()
  },
  methods: {
    search () {
      this.$emit('search', this.searchQuery)
    },
    autoCorsSearch (searchWord) {
      this.$emit('autoCorsSearch', searchWord)
    },
    onEnter (e) {
      let val = ''
      if (typeof e === 'object') {
        val = e.target.value
      } else if (typeof e === 'string') {
        val = e
      }

      let text = []
      // 2자 이상입력 체크
      if (val.length < 2 ) {
        // this.searchTextEnter = true
        if (!this.isPopupVisible) {
          this.isPopupVisible = true // 연속 엔터 방지
          this.$popup.alert(this.$el, {title: '검색어', contents: '검색어를 2글자 이상 입력해 주세요.'})
            .then(() => {
              this.isPopupVisible = false
            })
        }
        return
      }

      const recent = JSON.parse(window.localStorage.getItem('recent'))
      // localStorage 중복제거 및 저장
      if (recent) { // expireDate 확인
        if (moment(recent.expireDate).diff(moment()) < 0) {
          window.localStorage.removeItem('recent')
        } else {
          // 증복제거
          let removeIdx = recent.text.indexOf(val)
          if (removeIdx >= 0) {
            recent.text.splice(removeIdx, 1)
          }
          text = recent.text
        }
      }
      // recent 셋팅
      text.unshift(val)
      // 최대 6개
      if (text.length > 6) {
        text.splice(6)
      }
      // expireDate 셋팅
      const expireDate = moment().add(30, 'days')
      window.localStorage.setItem('recent', JSON.stringify({text: text, expireDate: expireDate}))

      this.search()
    },
    onClear () {
      this.searchQuery = ''
      this.onFocus()
    },
    onKeyup (e) {
      if (e.keyCode !== 13 && (e.keyCode < 38 || e.keyCode > 40)) {
        this.searchQuery = e.target.value
      }
    },
    onFocus () {
      this.$refs.mmpSearchInp.focus()
    },
    // MO 인풋 포커스 발생시 검색 UI 노출
    activeSearchUiMobile () {
      this.activeSearchUiMo = true
    },
    initSearch (fucusInput) {
      this.clearSearchKeyword(fucusInput)

      if (this.isMobile) this.activeSearchUiMo = false
    },
    // 검색어 입력창 키워드 제거 및 인풋 포커스 처리
    clearSearchKeyword (fucusInput) {
      const inp = this.$refs.mmpSearchInp

      this.currentKeyword = ''
      this.isTyping = false
      this.isSearchEnd = false

      if (fucusInput === undefined || fucusInput === null) fucusInput = true
      if (fucusInput) inp.focus()
    },
    // 검색 레이어 닫기
    closeSearchUi () {
      this.$emit('close')
    },
    // 검색결과 페이지에서 검색어 값이 넘어온 경우 input value 에 설정
    setInitSearchKeyword () {
      if (this.prePageSearchKeyword !== '') {
        this.searchQuery = this.prePageSearchKeyword
      }
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/search/TotalSearchInput.vue